import { useState as g } from "react";
import { arrayMove as f } from "@dnd-kit/sortable";
const p = ({ ids: o, onRemove: d, onSort: c }) => {
  const [s, e] = g(null);
  return {
    moveId: s,
    dndEvents: { onDragStart: (r) => {
      e(r.active.id);
    }, onDragEnd: (r) => {
      e(null);
      const { active: i, over: a } = r, n = String(i.id), t = a ? String(a.id) : null;
      if (!n || !t || n === t)
        return;
      if (t === "header") {
        d(n);
        return;
      }
      const l = o.indexOf(n), v = o.indexOf(t), u = f(o, l, v);
      c(u);
    }, onDragCancel: () => {
      e(null);
    } }
  };
};
export {
  p as default
};
